/* eslint-disable react/prop-types */ // TODO: add props
import { Link } from 'react-router-dom';
import cx from 'classnames';
import styles from './ChunkProgressIndicator.scss';
import { IconActivity } from './icons';

const ChunkProgressIndicator = ({
  viewed,
  hasQuestion,
  hasActivity,
  hasResult,
  marksAvailable = 1,
  marksObtained = 0,
  grouped,
  first,
  last,
  chunkTitle,
  chunkUrl,
  successMeasureResponseValue,
  hasSuccessMeasure,
  isVeryFirstChunk,
  isVeryLastChunk,
  shouldShowSelfRating,
}) => {
  const displayQuestion = hasQuestion && marksAvailable;
  const gotFullMarks = hasResult && marksObtained === marksAvailable;
  const gotLessThanFullMarks = hasResult && marksObtained < marksAvailable;
  let markSpan;

  if (displayQuestion && !hasSuccessMeasure) {
    const markString = hasResult ? `${marksObtained}/${marksAvailable}` : '-';
    markSpan = (
      <span className={cx(styles.marks, { [styles.marksFirstChunk]: first })}>
        {markString}
      </span>
    );
  }
  // TODO: constants?
  const successMeasureResponseLabel = {
    'not_yet': 'Not yet',
    'partly': 'Partly',
    'yes': 'Yes',
  }[successMeasureResponseValue];

  const bgClassNames = cx(styles.chunkProgressIndicator, {
    [styles.correctResponse]: displayQuestion && gotFullMarks,
    [styles.incorrectResponse]: displayQuestion && gotLessThanFullMarks,
    [styles.isFirst]: isVeryFirstChunk,
    [styles.isLast]: isVeryLastChunk,
  });

  const chunkClassNames = cx({
    [styles.hasQuestion]: hasQuestion,
    [styles.hasActivity]: hasActivity,
    [styles.viewed]: viewed,
    [styles.chunk]: !grouped,
    [styles.firstChunk]: first,
    [styles.middleChunk]: grouped && !first && !last,
    [styles.lastChunk]: last,
    [styles.successMeasureChunk]: hasSuccessMeasure,
    [styles.successMeasureResponseValueNotYet]:
      hasSuccessMeasure && successMeasureResponseLabel === 'Not yet',
    [styles.successMeasureResponseValuePartly]:
      hasSuccessMeasure && successMeasureResponseLabel === 'Partly',
    [styles.successMeasureResponseValueYes]:
      hasSuccessMeasure && successMeasureResponseLabel === 'Yes',
    [styles.veryFirstChunk]: isVeryFirstChunk && !grouped,
    [styles.veryFirstChunkNoSuccessMeasure]:
      isVeryFirstChunk && shouldShowSelfRating,
    [styles.markableQuestionChunks]: hasQuestion && marksAvailable,
    [styles.hasQuestionAndFirstChunk]: displayQuestion && first,
  });

  let successMeasureResponseValueSpan;
  if (successMeasureResponseValue) {
    successMeasureResponseValueSpan = (
      <span
        data-test="success-measure-response-cell"
        className={cx(styles.successMeasureResponseValue)}
      >
        {successMeasureResponseLabel}
      </span>
    );
  }

  return (
    <Link to={chunkUrl}>
      <div className={bgClassNames} title={chunkTitle}>
        <span className={chunkClassNames}>
          {hasActivity && <IconActivity />}
          {successMeasureResponseValueSpan}
        </span>
        {markSpan}
      </div>
    </Link>
  );
};

export default ChunkProgressIndicator;
